import i18n from "i18next";

import {
  AgriculturePolicyDetails,
  HazardIdEnum,
  LocationRiskAssessment,
  PolicyDetails,
} from "../hazardIdEnum";
import { PermissionIdEnum } from "../../util/types/permissions/permissionIdEnum";

const hailColorRange = ["#f9f9f9", "#f0e5ee", "#d4c1d4", "#b295b4", "#8b638f"];

export const getHailHazardsList = (): Hazard[] => [
  // {
  //   cysId: HazardIdEnum.HailEurLarge,
  //   name: "Hail Eur",
  //   permissions: ["CYS_RISK_HAIL_EUR_EURAINHAIL_C"],
  //   colorRange: hailColorRange,
  //   description: `The hail risk map layer shows the annual probability of large hail (greater than 20mm in diameter) falling in a given location. For example, a value of 0.03 means that the policy’s location has a 3% chance of being hit by large hail each year.
  //               Data comes from the RAIN Project, led by the European Severe Storm Laboratory.`,
  //   label: `${i18n.t("riskAssessment.hail")} (EUR) - Large`,
  //   pages: [PolicyDetails, LocationRiskAssessment],
  // },
  {
    cysId: HazardIdEnum.HailItaLarge,
    name: "Hail Ita Large",
    // permissions: ["CYS_RISK_HAIL_ITA_EURAIN_LARGE_C"],
    permissions: [PermissionIdEnum.HailItaLarge],
    colorRange: hailColorRange,
    description: i18n.t("riskExposureMapExplained.hailItaLarge", {
      size: i18n.t("riskExposureMapExplained.large"),
      mm: 20,
      scenario: "",
    }),
    label: `${i18n.t("riskAssessment.hail")} (ITA) - Large`,
    pages: [PolicyDetails, AgriculturePolicyDetails, LocationRiskAssessment],
  },
  {
    cysId: HazardIdEnum.HailItaLargeRcp45,
    name: "Hail Ita Large RCP 4.5",
    // permissions: ["CYS_RISK_HAIL_ITA_EURAIN_LARGE_RCP45_P2021-2050"],
    permissions: [PermissionIdEnum.HailItaLargeRcp45],
    colorRange: hailColorRange,
    description: i18n.t("riskExposureMapExplained.hailItaLarge", {
      size: i18n.t("riskExposureMapExplained.large"),
      mm: 20,
      scenario: i18n.t("riskExposureMapExplained.scenario45"),
    }),
    label: `${i18n.t("riskAssessment.hail")} (ITA) - Large - RCP 4.5`,
    pages: [PolicyDetails, LocationRiskAssessment],
  },
  {
    cysId: HazardIdEnum.HailItaLargeRcp85,
    name: "Hail Ita Large RCP 8.5",
    // permissions: ["CYS_RISK_HAIL_ITA_EURAIN_LARGE_RCP85_P2021-2050"],
    permissions: [PermissionIdEnum.HailItaLargeRcp85],
    colorRange: hailColorRange,
    description: i18n.t("riskExposureMapExplained.hailItaLarge", {
      size: i18n.t("riskExposureMapExplained.large"),
      mm: 20,
      scenario: i18n.t("riskExposureMapExplained.scenario85"),
    }),
    label: `${i18n.t("riskAssessment.hail")} (ITA) - Large - RCP 8.5`,
    pages: [PolicyDetails, LocationRiskAssessment],
  },
  {
    cysId: HazardIdEnum.HailItaExLarge,
    name: "Hail Ita Extra Large",
    // permissions: ["CYS_RISK_HAIL_ITA_EURAIN_EXLARGE_C"],
    permissions: [PermissionIdEnum.HailItaExLarge],
    colorRange: hailColorRange,
    description: i18n.t("riskExposureMapExplained.hailItaLarge", {
      size: i18n.t("riskExposureMapExplained.extremelyLarge"),
      mm: 50,
      scenario: "",
    }),
    label: `${i18n.t("riskAssessment.hail")} (ITA) - ExLarge`,
    pages: [PolicyDetails, AgriculturePolicyDetails, LocationRiskAssessment],
  },
  {
    cysId: HazardIdEnum.HailItaExLargeRcp45,
    name: "Hail Ita Extra Large RCP 4.5",
    // permissions: ["CYS_RISK_HAIL_ITA_EURAIN_EXLARGE_RCP45_P2021-2050"],
    permissions: [PermissionIdEnum.HailItaExLargeRcp45],
    colorRange: hailColorRange,
    description: i18n.t("riskExposureMapExplained.hailItaLarge", {
      size: i18n.t("riskExposureMapExplained.extremelyLarge"),
      mm: 50,
      scenario: i18n.t("riskExposureMapExplained.scenario45"),
    }),
    label: `${i18n.t("riskAssessment.hail")} (ITA) - ExLarge - RCP 4.5`,
    pages: [PolicyDetails, LocationRiskAssessment],
  },
  {
    cysId: HazardIdEnum.HailItaExLargeRcp85,
    name: "Hail Ita Extra Large RCP 8.5",
    // permissions: ["CYS_RISK_HAIL_ITA_EURAIN_EXLARGE_RCP85_P2021-2050"],
    permissions: [PermissionIdEnum.HailItaExLargeRcp85],
    colorRange: hailColorRange,
    description: i18n.t("riskExposureMapExplained.hailItaLarge", {
      size: i18n.t("riskExposureMapExplained.extremelyLarge"),
      mm: 50,
      scenario: i18n.t("riskExposureMapExplained.scenario85"),
    }),
    label: `${i18n.t("riskAssessment.hail")} (ITA) - ExLarge - RCP 8.5`,
    pages: [PolicyDetails, LocationRiskAssessment],
  },
];
